module.exports = __webpack_public_path__ + "static/media/icon-360.085c5097.svg";